<template>
  <div class="row">
    <div v-for="data in currentList" :key="data.id" class="col-xxl-3 col-lg-4 col-md-6 col-sm-12">
      <v-card hover style="border-radius: 20px !important;">
        <v-card-text>
          <div class="mt-4 text-center">
            <v-list-item dense two-line>
              <v-list-item-content dense>
                <v-list-item-title>Cari Kod</v-list-item-title>
                <v-list-item-subtitle>{{ data.code }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item dense two-line>
              <v-list-item-content dense>
                <v-list-item-title>Ünvan</v-list-item-title>
                <v-list-item-subtitle>{{ data.name }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item dense two-line>
              <v-list-item-content dense>
                <v-list-item-title>İl / İlçe</v-list-item-title>
                <v-list-item-subtitle>{{ data.city }} / {{data.town}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item dense two-line>
              <v-list-item-content dense>
                <v-list-item-title>Plasiyer</v-list-item-title>
                <v-list-item-subtitle>{{ data.salesPersonName }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item dense two-line>
              <v-list-item-content dense>
                <v-list-item-title>Borç / Alacak / Bakiye</v-list-item-title>
                <v-list-item-subtitle>
                  <b>{{numberConverter(data.debit)}} / {{numberConverter(data.credit)}} / {{numberConverter(data.balance)}}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <div>
              <v-menu
                  :v-model="showActionsMenu"
                  bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      class="mx-1"
                      small
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="showActionsMenu = data.code"
                  >
                    İşlemler
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                      @click="openCurrentStockActionsDialog(data)"
                  >
                    <v-list-item-icon>
                      <v-icon color="indigo darken-2">mdi-transfer</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Stok Hareketleri</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                      @click="openCurrentActionsDialog(data)"
                  >
                    <v-list-item-icon>
                      <v-icon color="secondary darken-2">mdi-briefcase-arrow-left-right-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Cari Hareketleri</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                      @click="openCurrentUnclosedInvoicesDialog(data)"
                  >
                    <v-list-item-icon>
                      <v-icon color="amber darken-2">mdi-file-document-alert-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Kapatılmamış Faturalar</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                      @click="openCurrentUnclosedInvoicesDialog(data)"
                  >
                    <v-list-item-icon>
                      <v-icon color="amber darken-2">mdi-wallet-travel</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Ziyaretler</v-list-item-title>
                  </v-list-item>

                </v-list>
              </v-menu>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </div>
    <CurrentStockActionsDialog
        :showDialog="showCurrentStockActionsDialog"
        :currentProp="currentStockActionsProp"
        @dialogChange="data => (showCurrentStockActionsDialog = data)"
    ></CurrentStockActionsDialog>
    <CurrentActionsDialog
        :showDialog="showCurrentActionsDialog"
        :currentProp="currentActionsProp"
        @dialogChange="data => (showCurrentActionsDialog = data)"
    ></CurrentActionsDialog>
    <CurrentUnclosedInvoicesDialog
        :showDialog="showCurrentUnclosedInvoicesDialog"
        :currentProp="currentUnclosedInvoicesProp"
        @dialogChange="data => (showCurrentUnclosedInvoicesDialog = data)"
    ></CurrentUnclosedInvoicesDialog>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import {numberConverter} from "../../../../helpers";
import CurrentActionsDialog from "@/components/current/dialogs/CurrentActionsDialog.vue";
import CurrentStockActionsDialog from "@/components/current/dialogs/CurrentStockActionsDialog.vue";
import CurrentUnclosedInvoicesDialog from "@/components/current/dialogs/CurrentUnclosedInvoicesDialog.vue";

export default {
  components: {
    CurrentUnclosedInvoicesDialog, CurrentStockActionsDialog, CurrentActionsDialog
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("cart", ["current"]),
    ...mapState("current", [
      "currentList",
      "currentListHeaders",
      "currentListLoading",
      "currentListMetaData",
      "noCurrentMessage",
    ]),
    ...mapGetters("cart", ["getCurrent"]),
  },
  data() {
    return {
      showActionsMenu: false,
      showCurrentStockActionsDialog: false,
      showCurrentActionsDialog: false,
      showCurrentUnclosedInvoicesDialog: false,
      currentStockActionsProp: null,
      currentActionsProp: null,
      currentUnclosedInvoicesProp: null
    };
  },
  methods: {
    numberConverter,
    closeMenu() {
      this.showActionsMenu = false;
    },
    openCurrentStockActionsDialog(data) {
      this.currentStockActionsProp = data;
      this.showCurrentStockActionsDialog = true;
      this.closeMenu()
    },
    openCurrentActionsDialog(data) {
      this.currentActionsProp = data;
      this.showCurrentActionsDialog = true;
      this.closeMenu()
    },
    openCurrentUnclosedInvoicesDialog(data) {
      this.currentUnclosedInvoicesProp = data;
      this.showCurrentUnclosedInvoicesDialog = true;
      this.closeMenu()
    }
  },
};
</script>
